module.exports = __webpack_public_path__ + "static/media/Setup-Required.d04b6752.svg";